export default "__VITE_ASSET__BE2GqP_F__"